import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Checkbox from 'src/components/Checkbox';
import useGetRequest from 'src/hooks/useGetRequest';
import { Role } from '../../../../../types';

const AssignRolesInspector = ({
  workflowId,
  selectedWidget,
  saveWidget,
  getPerspective
}: any) => {
  const { result: roles, isLoading: rolesAreLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/roles/`,
    initialResult: [],
  });
  const rolesByRoleId: Record<string, Role> = {};
  roles.forEach((role: any) => {
    rolesByRoleId[role.id] = role;
  });

  const updateRoleIds = (roleId: any, isChecked: any) => {
    const selectedRoleIds = selectedWidget.data.roleIds || [];
    saveWidget(selectedWidget.id, {
      data: {
        ...selectedWidget.data,
        roleIds: isChecked ? (
          [...selectedRoleIds, roleId]
        ) : (
          selectedRoleIds.filter((_roleId: any) => _roleId !== roleId)
        )
      }
    });
  };

  if (rolesAreLoading) return null;

  return (
    <Box mt={2}>
      {
        roles.map((role: any) => (
          <Box display="flex" alignItems="center" mb={1}>
            <Box pl={1}>
              <Checkbox
                // hack cuz im lazy
                checked={(selectedWidget.data.roleIds || []).includes(role.id)}
                onChange={(e: any) => updateRoleIds(role.id, e.target.checked)}
              />
            </Box>
            <Box>
              <Typography variant="subtitle1">
                {role.name}
              </Typography>
            </Box>
          </Box>
        ))
      }
    </Box>
  );
};

export default AssignRolesInspector;
